import React from "react";
import Helmet from "react-helmet";
import styled, { injectGlobal } from "styled-components";
import { Provider as ThemeProvider } from "rebass";
import { debounce } from "lodash";
import componentQueries from "react-component-queries";
import Menu from "./menu/menu";
import { globalStyles, theme } from "./global-styles";
import Spinner from "../components/spinner";

export const VIEWPORT_PADDING_TOP = "15vh";
export const VIEWPORT_PADDING_BOTTOM = "12vh";

const ViewportContainer = styled.div`
  min-height: 100vh;
  padding-top: ${VIEWPORT_PADDING_TOP};
  padding-bottom: ${VIEWPORT_PADDING_BOTTOM};
  padding-left: ${({ margin }) => margin[0]};
  padding-right: ${({ margin }) => margin[1]};
`;

const SpinContainer = styled.div`
  width: 100%;
  height: 100vh;
  background-color: white;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
`;

/* eslint no-unused-expressions: off */
injectGlobal`
${globalStyles}
`;

class Layout extends React.Component {
  constructor() {
    super();
    this.confirmWidth = debounce(this.confirmWidth, 1000).bind(this);
  }

  state = {
    widthConfirmed: false
  };

  componentWillMount() {
    this.confirmWidth();
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.widthConfirmed && nextProps.width !== this.props.width) {
      this.confirmWidth();
    }
  }

  confirmWidth() {
    this.setState({
      widthConfirmed: true
    });
  }

  render() {
    const { layoutProps, theme: passedThemes } = this.props;
    const { widthConfirmed } = this.state;
    return (
      <div>
        {!widthConfirmed && (
          <SpinContainer>
            <Spinner />
          </SpinContainer>
        )}
        <ThemeProvider
          theme={{
            ...theme,
            ...passedThemes
          }}
        >
          <Helmet>
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1"
            />
            <meta charSet="UTF-8" />
          </Helmet>
          <ViewportContainer {...layoutProps}>
            {this.props.children()}
          </ViewportContainer>
          <Menu />
        </ThemeProvider>
      </div>
    );
  }
}

const mapWidthToMobileMenuProps = width => {
  if (width > 1000) {
    return {
      width: "30vw"
    };
  }
  if (width > 700) {
    return {
      width: "40vw"
    };
  }
  return {
    width: "100vw"
  };
};

const mapWidthToLayoutProps = width => {
  if (width >= 1279) {
    return {
      margin: ["12%", "8%"]
    };
  }

  return {
    margin: ["5%", "5%"]
  };
};

const getFrameProps = (width, orientation) => {
  const dFault = {
    px: 11,
    pt: orientation.vertical ? 16 : 13,
    pb: 10,
    fs: orientation.vertical ? [14, 13] : [13, 10]
  };

  if (width > 1280) {
    return {
      ...dFault,
      pt: 9,
      pb: 9,
      fs: [13, 10]
    };
  }

  if (width > 1000) {
    return {
      ...dFault,
      pt: orientation.vertical ? 14 : 11,
      pb: 10,
      fs: orientation.vertical ? [15, 13] : [13, 10]
    };
  }

  if (width > 700) {
    return {
      ...dFault,
      pt: orientation.vertical ? 15 : 12,
      pb: 10,
      fs: orientation.vertical ? [15, 13] : [13, 10]
    };
  }

  return dFault;
};

export default componentQueries(size => {
  const { width } = size;
  const orientation = {
    vertical: width < window.innerHeight,
    horizontal: width > window.innerHeight
  };
  return {
    layoutProps: mapWidthToLayoutProps(width),
    width,
    theme: {
      orientation,
      frame: getFrameProps(width, orientation),
      mobile: {
        isMobile: width < 1280,
        menu: {
          layoutProps: mapWidthToMobileMenuProps(width)
        }
      }
    }
  };
})(Layout);



// WEBPACK FOOTER //
// ./src/layouts/index.js